import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import VitalsCreateForm from './VitalsCreateForm';

const styles = theme => ({
  form: {
    padding: '35px 85px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

const VitalsCreateDialog = ({
  form,
  open,
  submitting,
  onClose,
  onSubmitSuccess,
  actions,
  classes,
  ...otherProps
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Vitals
      </Typography>
    </DialogTitle>
    <DialogContent>
      <VitalsCreateForm
        form={form}
        className={classes.form}
        {...{ 'Record Number': otherProps['Record Number'] }}
        onSubmitSuccess={(values) => {
          onSubmitSuccess(values);
          onClose();
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

VitalsCreateDialog.propTypes = {
  form: PropTypes.string,
  open: PropTypes.bool,
  'Record Number': PropTypes.number.isRequired,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

VitalsCreateDialog.defaultProps = {
  form: 'patientVitalsCreate',
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('patientVitalsCreate')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(VitalsCreateDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Vitals/VitalsCreateDialog.js